import { render, staticRenderFns } from "./aiFace.vue?vue&type=template&id=dbec6918&scoped=true&"
import script from "./aiFace.vue?vue&type=script&lang=js&"
export * from "./aiFace.vue?vue&type=script&lang=js&"
import style0 from "./aiFace.vue?vue&type=style&index=0&id=dbec6918&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbec6918",
  null
  
)

export default component.exports